import React, { memo } from "react";
import { ButtonInjectStyle } from "./Button/styled";
import { CheckboxInjectStyle } from "./Checkbox/styled";
import { DropdownInjectStyle } from "./Dropdown/styled";
import { InputInjectStyle } from "./Input/styled";
import { MessageInjectStyle } from "./Message/styled";
import { ModalInjectStyle } from "./Modal/styled";
import { PopoverInjectStyle } from "./Popover/styled";
import { TooltipInjectStyle } from "./Tooltip/styled";
import { SelectInjectStyle, SelectDropdownInjectStyle } from "./Select/styled";
import { SkeletonInjectStyle } from "./Skeleton/styled";

export const AntdOverrideStyle = memo(() => {
  return (
    <>
      {
        // process.env.PLUGIN为插件全局变量，插件模式下，不加载全局样式，
        <>
          <SelectInjectStyle />
          <ButtonInjectStyle />
          <CheckboxInjectStyle />
          <DropdownInjectStyle />
          <InputInjectStyle />
          <MessageInjectStyle />
          <ModalInjectStyle />
          <SkeletonInjectStyle />
          <PopoverInjectStyle />
          <TooltipInjectStyle />
          <SelectDropdownInjectStyle />
        </>
      }
    </>
  );
});
